var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-trail",style:(_vm.styles),attrs:{"id":_vm.$attrs._id}},[_c('fa',{staticClass:"tag-trail__icon",attrs:{"icon":['fad', _vm.faIcon]}}),_c('div',{staticClass:"tag-trail__label",domProps:{"innerHTML":_vm._s(_vm.label[_vm.lang])}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }